
  import React from "react"
  import Component from "/Users/mookyungkwak/Projects/gatsby-casper-blog/src/layouts/index.jsx"
  import data from "/Users/mookyungkwak/Projects/gatsby-casper-blog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js